import React from 'react';
import styled from 'styled-components';

interface TabButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  mode?: 'light' | 'dark';
}

const StyledButton = styled.button<{ isActive: boolean; mode?: 'light' | 'dark' }>`
  background: none;
  border: none;
  padding: 12px 16px;
  cursor: pointer;
  position: relative;
  color: ${({ mode, isActive }) => 
    isActive 
      ? (mode === 'light' ? '#616161' : '#d0d0d0')
      : (mode === 'light' ? '#131313' : '#d0d0d0')
  };
  font-family: 'Inter';
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ isActive }) => (isActive ? 700 : 400)};
  line-height: 140%;
  text-transform: none;
  white-space: nowrap;
  transition: color 0.2s ease, opacity 0.2s ease;
  border-bottom: ${({ isActive }) => (isActive ? '2px solid #1976d2' : '2px solid transparent')};
  
  /* Reserve space for bold text to prevent layout shift */
  &::after {
    content: attr(data-label);
    font-weight: 700;
    height: 0;
    visibility: hidden;
    overflow: hidden;
    user-select: none;
    pointer-events: none;
    display: block;
  }
  
  &:hover {
    opacity: 0.8;
  }
  
  &:focus {
    outline: none;
  }
`;

const TabButton: React.FC<TabButtonProps> = ({ label, isActive, onClick, mode }) => {
  return (
    <StyledButton 
      isActive={isActive} 
      onClick={onClick} 
      mode={mode}
      data-label={label}
    >
      {label}
    </StyledButton>
  );
};

export default TabButton;
